import { StoreConsumptionStatus } from "@gtpl/shared-models/procurement-management";
import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, IsEnum, IsNotEmpty, IsNumber, IsOptional } from "class-validator";
import { StoreConsumptionItemsData } from "./store-consumption-items.dto";

export class StoreConsumptionData {
    @ApiProperty()
    @IsNotEmpty()
    consumedDate: Date;

    @ApiProperty()
    @IsNotEmpty()
    saleOrderId: number;
   

    @ApiProperty()
    @IsNotEmpty()
    tracebilityCode: number;

    @ApiProperty()
    @IsNotEmpty()
    indentDate: Date;

    @ApiProperty()
    @IsNotEmpty()
    indentNo: string;
    @ApiProperty()
    @IsNotEmpty()
    salePerson: number;

    @ApiProperty({ enum: Object.values(StoreConsumptionStatus) })
    @IsNotEmpty()
    @IsEnum(StoreConsumptionStatus)
    status: StoreConsumptionStatus;


    @ApiProperty()
    @IsNotEmpty()
    storeConsumedCode: string;

    @ApiProperty()
    @IsNotEmpty()
    createdUser: string;

    @ApiProperty({ type: [StoreConsumptionItemsData] })
    storeConsumptionItems: StoreConsumptionItemsData[];

    @ApiProperty()
    @IsOptional()
    storeConsumptionId?: number;

    @ApiProperty()
    @IsOptional()
    updatedUser?: string | null;

    @ApiProperty()
    @IsNotEmpty()
    unitId: number;
    @ApiProperty()
    @IsNotEmpty()
    saleOrderItemId?: number;

    @ApiProperty()
    soType:string;

    @ApiProperty()
    issuedTo?:number;


    /**
     * 
     * @param consumedDate 
     * @param saleOrderId 
     * @param indentDate 
     * @param indentNo 
     * @param status 
     * @param storeConsumedCode 
     * @param createdUser 
     * @param storeConsumptionItems 
     * @param storeConsumptionId 
     * @param updatedUser 
     */
    constructor(consumedDate: Date, saleOrderId: number, indentDate: Date, indentNo: string, salePerson: number, status: StoreConsumptionStatus, storeConsumedCode: string, createdUser: string, unitId: number, storeConsumptionItems: StoreConsumptionItemsData[], storeConsumptionId?: number, updatedUser?: string | null,saleOrderItemId?: number,soType?:string,    issuedTo?:number
    ) {
        this.consumedDate = consumedDate;
        this.saleOrderId = saleOrderId;
        this.indentDate = indentDate;
        this.indentNo = indentNo;
        this.salePerson = salePerson;
        this.storeConsumedCode = storeConsumedCode;
        this.status = status;
        this.createdUser = createdUser;
        this.storeConsumptionItems = storeConsumptionItems;
        this.storeConsumptionId = storeConsumptionId;
        this.updatedUser = updatedUser;
        this.unitId = unitId;
        this.saleOrderItemId = saleOrderItemId;
        this.soType = soType;
        this.issuedTo=issuedTo
    }
}